import { formatINR } from '@/lib/format';

/** Money is integer paise everywhere; this is the only place it becomes rupees. */
export default function Money({ paise, mrp, className = '' }) {
  return (
    <span className={className}>
      {formatINR(paise)}
      {mrp ? <span className="ml-2 text-sm line-through opacity-50">{formatINR(mrp)}</span> : null}
    </span>
  );
}
